export function formatAppointmentDate(dateString: string): string {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return dateString;
  }
}

export function formatAppointmentTime(dateString: string): string {
  try {
    const date = new Date(dateString);
    return date.toLocaleTimeString('es-VE', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch {
    return '';
  }
}

// lib/utils/date-utils.ts
export const formatTimeElapsed = (lastSettlement: any) => {
  if (!lastSettlement) return 'Primer periodo';

  // 1. Normalizar a Milisegundos (Sea Date, Timestamp o ms)
  const startDateMs = lastSettlement?.seconds
    ? lastSettlement.seconds * 1000
    : new Date(lastSettlement).getTime();

  const now = Date.now();
  const diff = now - startDateMs;

  // Si por error de sync la fecha es futura, evitamos números locos
  if (diff < 0) return 'Empezó hace poco';

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);

  if (days === 0 && hours === 0) return 'Hace menos de una hora';
  if (days === 0) return `Hace ${hours} hr${hours > 1 ? 's' : ''}`;

  return `${days} día${days > 1 ? 's' : ''} y ${hours} hr${hours > 1 ? 's' : ''}`;
};
